import { DownOutlined } from '@ant-design/icons';
import { smallTimeOptions } from 'assets/styles/constants';
import { useManagePermittedRoles } from 'library/hooks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Loader, ProfileImageComponent } from 'zComponents/atoms';
import MetaInfoContainer from 'zComponents/atoms/MetaInfoContainer';
import { PeopleActionDropdown } from 'zComponents/molecules';
import { Button, Card, Col, Dropdown, Flex, Row, Tag, Tooltip, Typography } from 'zui/Antd';

const { Text } = Typography;

const PeopleSummaryCard = ({ data }) => {
	const [loadings, setLoading] = useState(true);
	const [peopleList, setPeopleList] = useState([]);
	const { data: peopleData } = useSelector((state) => state.People);
	const { data: teamsData } = useSelector((state) => state.Teams);
	// const displayNames = useGetPersonDisplayName(true);

	useEffect(() => {
		setLoading(true);
		if (data && Object.keys(data).length > 0) {
			setPeopleList(peopleData);
			setLoading(false);
		}
	}, [data, peopleData]);

	// HOC
	// const PersonWithLink = WithHyperLink((a) => {
	// 	return <p>{a.children}</p>;
	// });

	const isPermittedManageMember = useManagePermittedRoles('manageMembers', {
		orgID: [teamsData[0]?.orgID],
		teamID: [teamsData.map((item) => item.teamID)]
	});

	return loadings ? (
		<Loader />
	) : (
		<Card>
			<Row>
				<Col xl={6} lg={24} sm={24}>
					<ProfileImageComponent entityObject={data} entityName={'People'} />
				</Col>
				<Col xl={18} lg={24} sm={24}>
					<Row>
						<Col span={12}>
							<Text
								style={{
									fontSize: '25px',
									lineHeight: '30px'
								}}
							>
								{data.displayName}
							</Text>
						</Col>
						<Col span={12}>
							<Flex gap={8}>
								{peopleList.length > 0 ? (
									<Dropdown
										menu={{
											items: peopleList
												.filter((person) => person.personID !== data.personID)
												.map((person) => ({
													key: person.personID,
													label: person.displayName
												}))
										}}
										trigger={['click']}
									>
										<Button>
											Switch Profile <DownOutlined />
										</Button>
									</Dropdown>
								) : null}
								{data.deletedDate ? (
									<Tooltip
										key={data.personID}
										title={new Date(data.deletedDate).toLocaleString('en-AU', smallTimeOptions)}
										placement='top'
										color='red'
									>
										<div>
											<Tag color='red' className='deletedTag'>
												DELETED
											</Tag>
										</div>
									</Tooltip>
								) : isPermittedManageMember ? (
									<PeopleActionDropdown data={data} hideView size={'medium'} />
								) : null}
							</Flex>
						</Col>
						<Col span={24}>
							<Text className='fBID'>ID: {data.fBPersonID}</Text>
						</Col>
					</Row>
					<Row>
						<Col lg={24}>
							<Flex wrap gap={8}>
								<Flex align='center' gap={4}>
									<Text strong>First Name: </Text>
									<Text>{data.firstName}</Text>
								</Flex>
								<Flex align='center' gap={4}>
									<Text strong>Last Name: </Text>
									<Text>{data.lastName}</Text>
								</Flex>
								<Flex align='center' gap={4}>
									<Text strong>Employee ID: </Text>
									<Text>{data.employeeID ? data.employeeID : 'N/A'}</Text>
								</Flex>
								<Flex align='center' gap={4}>
									<Text strong>Sex: </Text>
									<Text>{data.sex ? data.sex : 'N/A'}</Text>
								</Flex>
								<Flex align='center' gap={4}>
									<Text strong>Email: </Text>
									<Text>{data.email}</Text>
								</Flex>
								<Flex align='center' gap={4}>
									<Text strong>Date Of Birth: </Text>
									<Text>
										{data.dOB
											? new Date(data.dOB).toLocaleString('en-AU', smallTimeOptions)
											: 'N/A'}
									</Text>
								</Flex>
							</Flex>

							{data.roles && Object.keys(data.roles).length > 0 && (
								<Col lg={24} md={24} sm={24} xs={24}>
									<div className='personRole'>Roles</div>
									<div>{/* <RolesSummary roles={data.roles} /> */}</div>
								</Col>
							)}
						</Col>
					</Row>
				</Col>
			</Row>

			<MetaInfoContainer
				createDate={data.createdDate}
				modifiedDate={data.modifiedDate}
				deleteDate={data.deletedDate}
			/>
		</Card>
	);
};

export default PeopleSummaryCard;
